import { render, staticRenderFns } from "./ResetPositionDialog.vue?vue&type=template&id=05554c4c&scoped=true"
import script from "./ResetPositionDialog.vue?vue&type=script&lang=js"
export * from "./ResetPositionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05554c4c",
  null
  
)

export default component.exports